import i18n from "@/plugins/i18n";

export enum Entgratart {
	None = 0,
	Manually = 1,
	Webern = 2,
	Trowalisieren = 3,
	BothSides = 4,
	Undefined = 5,
}

export function getEntgratartText(value: Entgratart): string {
	switch (value) {
		case Entgratart.None:
			return i18n.t("dtoLabels.entgratart.notEntgraten") as string;
		case Entgratart.Manually:
			return i18n.t("dtoLabels.entgratart.manually") as string;
		case Entgratart.Webern:
			return i18n.t("dtoLabels.entgratart.oneSided") as string;
		case Entgratart.Trowalisieren:
			return i18n.t("dtoLabels.entgratart.trowalisieren") as string;
		case Entgratart.BothSides:
			return i18n.t("dtoLabels.entgratart.bothSides") as string;
		case Entgratart.Undefined:
			return i18n.t("dtoLabels.entgratart.undefinedState") as string;
		default:
			return i18n.t("dtoLabels.entgratart.notAvailable") as string;
	}
}
